import { useEffect, useState } from 'react';
import { BottomModal } from '../../shared/BottomModal';
import { Button } from '../../Button';
import { apiUser } from '../../../api/apiUser.api';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { toast } from 'react-toastify';

export function BlockUser({ userId, onTriggerClick }) {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);

  const [isOpen, onClose] = useState(false);
  const [blocked, setBlocked] = useState({
    isBlocked: false,
    blockedByMe: false,
    blockedMe: false,
  });

  const handleBlockUser = async () => {
    if (!userId) return;
    setIsLoading(true);

    try {
      const result = await apiUser.fetchBlockUserById(axiosPrivate, userId);
      setBlocked((prev) => ({ ...prev, isBlocked: result.data.blocked }));
    } catch (error) {
      console.error('[BlockUser] Error to handleBlockUser:', error);
      toast.error(error.response.data.message || 'Ошибка');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUnblockUser = async () => {
    if (!userId) return;
    setIsLoading(true);

    try {
      const result = await apiUser.fetchUnblockUserById(axiosPrivate, userId);
      setBlocked((prev) => ({ ...prev, isBlocked: result.data.blocked }));
    } catch (error) {
      console.error('[BlockUser] Error to handleUnblockUser:', error);
      toast.error(error.response.data.message || 'Ошибка');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    apiUser
      .fetchCheckBlock(axiosPrivate, userId)
      .then((res) => setBlocked(res.data))
      .finally(() => setIsLoading(false));
  }, []);

  if (blocked.blockedMe) return;

  return (
    <>
      <div
        className="w-full h-[60px] flex items-center justify-between pl-[16px] pr-[16px]"
        onClick={() => {
          onTriggerClick?.();
          onClose(true);
        }}
      >
        <span>{blocked.isBlocked ? 'Разблокировать' : 'Заблокировать'}</span>
        <img src="/icons/block_user.svg" />
      </div>
      <BottomModal isOpen={isOpen} onClose={onClose}>
        <div className="px-4 text-white overflow-auto">
          <img className="size-[80px] mx-auto mb-8 mt-5" src="/icons/blocked_success.svg" alt="blocked_success" />
          {blocked.isBlocked ? (
            <div className="flex flex-col justify-start items-center w-full">
              <p className="text-center font-semibold text-[22px]">
                Пользователь был успешно заблокирован! Больше вас не побеспокоят
              </p>
              <div className="text-black mt-[40px]">
                <Button onClick={handleUnblockUser} disabled={isLoading}>
                  Разблокировать
                </Button>
              </div>
              <button
                className="text-[#FFFFFF] opacity-50 mt-[20px] h-16"
                onClick={() => {
                  onClose(false);
                }}
                disabled={isLoading}
              >
                Отмена
              </button>
            </div>
          ) : (
            <div className="flex flex-col justify-start items-center w-full">
              <p className="text-center font-semibold text-[22px]">
                Заблокировать пользователя?
              </p>
              <p className="text-center text-[16px] mt-[20px] font-normal pl-2 pr-2">
                Он больше не сможет видеть ваш профиль и писать вам. Все чаты и уведомления от него будут скрыты
              </p>
              <div className="text-black my-[32px]">
                <Button onClick={handleBlockUser} disabled={isLoading}>
                  Заблокировать
                </Button>
              </div>
            </div>
          )}
        </div>
      </BottomModal>
    </>
  );
}
